export class StripeTransaction {
    constructor(
        public amenityName: string = '',
        public amount: number = null,
        public bookingId: number = null,
        public bookingNumber: string = '',
        public buildingName: string = '',
        public fee: number = null,
        public id: number = null,
        public net: number = null,
        public paymentAtUtc: string = '',
        public refunded: number = null,
        public residentName: string = '',
        public stripeTransaction: string = '',
        public suiteNumber: string = '',
        public createdAt: string = '',
        public hasPayout: boolean = false,
        public checked: boolean = false
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/StripeTransaction.ts